export const randomColor = () => {
  const randomColorNumber = (min, max) =>
    Math.floor(Math.random() * (max - min) + min);
  const generatedColor = colorsSet[randomColorNumber(0, colorsSet.length)];
  colorsSet.splice(generatedColor, 1);

  return generatedColor;
};

const colorsSet = [
  "rgb(0,0,255)",
  "rgb(255,0,0)",
  "rgb(0,255,0)",
  "rgb(255,0,255)",
  "rgb(0,255,255)",
  "rgb(255,255,0)",
  "rgb(127,0,0)",
  "rgb(0,127,0)",
  "rgb(0,0,127)",
  "rgb(127,127,0)",
  "rgb(127,0,127)",
  "rgb(0,127,127)",
  "rgb(127,127,127)",
  "rgb(127,0,255)",
  "rgb(0,127,255)",
  "rgb(127,127,255)",
  "rgb(255,127,0)",
  "rgb(255,0,127)",
  "rgb(255,127,127)",
  "rgb(127,255,0)",
  "rgb(0,255,127)",
  "rgb(127,255,127)",
  "rgb(255,127,255)",
  "rgb(127,255,255)",
  "rgb(255,255,127)",
  "rgb(63,0,0)",
  "rgb(191,0,0)",
  "rgb(63,127,0)",
  "rgb(63,0,127)",
  "rgb(191,127,0)",
  "rgb(191,0,127)",
  "rgb(63,127,127)",
  "rgb(191,127,127)",
  "rgb(0,63,0)",
  "rgb(127,63,0)",
  "rgb(0,191,0)",
  "rgb(0,63,127)",
  "rgb(127,191,0)",
  "rgb(127,63,127)",
  "rgb(0,191,127)",
  "rgb(127,191,127)",
  "rgb(0,0,63)",
  "rgb(127,0,63)",
  "rgb(0,127,63)",
  "rgb(0,0,191)",
  "rgb(127,127,63)",
  "rgb(127,0,191)",
  "rgb(0,127,191)",
  "rgb(127,127,191)",
  "rgb(63,63,0)",
  "rgb(191,63,0)",
  "rgb(63,191,0)",
  "rgb(63,63,127)",
  "rgb(191,191,0)",
  "rgb(191,63,127)",
  "rgb(63,191,127)",
  "rgb(191,191,127)",
  "rgb(63,0,63)",
  "rgb(191,0,63)",
  "rgb(63,127,63)",
  "rgb(63,0,191)",
  "rgb(191,127,63)",
  "rgb(191,0,191)",
  "rgb(63,127,191)",
  "rgb(191,127,191)",
  "rgb(0,63,63)",
  "rgb(127,63,63)",
  "rgb(0,191,63)",
  "rgb(0,63,191)",
  "rgb(127,191,63)",
  "rgb(127,63,191)",
  "rgb(0,191,191)",
  "rgb(127,191,191)",
  "rgb(63,63,63)",
  "rgb(191,63,63)",
  "rgb(63,191,63)",
  "rgb(63,63,191)",
  "rgb(191,191,63)",
  "rgb(191,63,191)",
  "rgb(63,191,191)",
  "rgb(191,191,191)",
  "rgb(191,0,255)",
  "rgb(0,63,255)",
  "rgb(191,127,255)",
  "rgb(0,191,255)",
  "rgb(63,63,255)",
  "rgb(127,63,255)",
  "rgb(63,191,255)",
  "rgb(127,191,255)",
  "rgb(191,63,255)",
  "rgb(191,191,255)",
  "rgb(255,63,0)",
  "rgb(255,191,0)",
  "rgb(255,63,127)",
  "rgb(255,191,127)",
  "rgb(255,0,63)",
  "rgb(255,127,63)",
  "rgb(255,0,191)",
  "rgb(255,127,191)",
  "rgb(255,63,63)",
];
